import { useRecordContext } from "react-admin";
import SessionProfessors from "../Exams/components/SessionProfessors";
import { groupByCommission } from "../helpers";

const ProfessorsModeWraper = ({ disciplineId }) => {
  const record = useRecordContext();
  const professors = record?.professors || [];
  const commissions = groupByCommission(professors);

  return (
    <SessionProfessors
      disciplineId={disciplineId}
      defaultValue={commissions}
    />
  );
};
export default ProfessorsModeWraper;
